const Images = {
    logo: require("../Assets/kudoss-logo2.svg"),
    slider2: require("../Assets/img/adult-business-businessman-1061588.jpg"),
    slider1: require("../Assets/img/adult-apple-device-business-340152.jpg"),
    slider3: require("../Assets/img/IMG_20181123_110217_Bokeh.jpg")
};

export default Images;